import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
var _excluded = ["mode"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import axios from 'axios';
var IAuth = /*#__PURE__*/_createClass(function IAuth() {
  _classCallCheck(this, IAuth);
  this.mode = typeof window === 'undefined' ? 'json' : 'cookie';
});
var Meta;
(function (Meta) {
  Meta["TOTAL_COUNT"] = "total_count";
  Meta["FILTER_COUNT"] = "filter_count";
})(Meta || (Meta = {}));
var EmptyParamError = /*#__PURE__*/function (_Error) {
  _inherits(EmptyParamError, _Error);
  var _super = _createSuper(EmptyParamError);
  function EmptyParamError(paramName) {
    _classCallCheck(this, EmptyParamError);
    return _super.call(this, "".concat(paramName !== null && paramName !== void 0 ? paramName : 'ID', " cannot be an empty string"));
  }
  return _createClass(EmptyParamError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ItemsHandler = /*#__PURE__*/function () {
  function ItemsHandler(collection, transport) {
    _classCallCheck(this, ItemsHandler);
    this.collection = collection;
    this.transport = transport;
    this.endpoint = collection.startsWith('directus_') ? "/".concat(collection.substring(9)) : "/items/".concat(collection);
  }
  _createClass(ItemsHandler, [{
    key: "readOne",
    value: function () {
      var _readOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, query, options) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!("".concat(id) === '')) {
                _context.next = 2;
                break;
              }
              throw new EmptyParamError('id');
            case 2:
              _context.next = 4;
              return this.transport.get("".concat(this.endpoint, "/").concat(encodeURI(id)), _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function readOne(_x, _x2, _x3) {
        return _readOne.apply(this, arguments);
      }
      return readOne;
    }()
  }, {
    key: "readMany",
    value: function () {
      var _readMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ids, query, options) {
        var _a, collectionFields, primaryKeyField, _yield$this$transport, data, meta;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.transport.get("/fields/".concat(this.collection));
            case 2:
              collectionFields = _context2.sent;
              primaryKeyField = (_a = collectionFields.data) === null || _a === void 0 ? void 0 : _a.find(function (field) {
                return field.schema.is_primary_key === true;
              });
              _context2.next = 6;
              return this.transport.get("".concat(this.endpoint), _objectSpread({
                params: _objectSpread(_objectSpread({}, query), {}, {
                  filter: _objectSpread(_defineProperty({}, primaryKeyField.field, {
                    _in: ids
                  }), query === null || query === void 0 ? void 0 : query.filter),
                  sort: (query === null || query === void 0 ? void 0 : query.sort) || primaryKeyField.field
                })
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 6:
              _yield$this$transport = _context2.sent;
              data = _yield$this$transport.data;
              meta = _yield$this$transport.meta;
              return _context2.abrupt("return", _objectSpread({
                data: data
              }, meta && {
                meta: meta
              }));
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function readMany(_x4, _x5, _x6) {
        return _readMany.apply(this, arguments);
      }
      return readMany;
    }()
  }, {
    key: "readByQuery",
    value: function () {
      var _readByQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query, options) {
        var _yield$this$transport2, data, meta;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.transport.get("".concat(this.endpoint), _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 2:
              _yield$this$transport2 = _context3.sent;
              data = _yield$this$transport2.data;
              meta = _yield$this$transport2.meta;
              return _context3.abrupt("return", _objectSpread({
                data: data
              }, meta && {
                meta: meta
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function readByQuery(_x7, _x8) {
        return _readByQuery.apply(this, arguments);
      }
      return readByQuery;
    }()
  }, {
    key: "createOne",
    value: function () {
      var _createOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item, query, options) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.transport.post("".concat(this.endpoint), item, _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 2:
              return _context4.abrupt("return", _context4.sent.data);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createOne(_x9, _x10, _x11) {
        return _createOne.apply(this, arguments);
      }
      return createOne;
    }()
  }, {
    key: "createMany",
    value: function () {
      var _createMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(items, query, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.transport.post("".concat(this.endpoint), items, _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 2:
              return _context5.abrupt("return", _context5.sent);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createMany(_x12, _x13, _x14) {
        return _createMany.apply(this, arguments);
      }
      return createMany;
    }()
  }, {
    key: "updateOne",
    value: function () {
      var _updateOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, item, query, options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!("".concat(id) === '')) {
                _context6.next = 2;
                break;
              }
              throw new EmptyParamError('id');
            case 2:
              _context6.next = 4;
              return this.transport.patch("".concat(this.endpoint, "/").concat(encodeURI(id)), item, _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 4:
              return _context6.abrupt("return", _context6.sent.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateOne(_x15, _x16, _x17, _x18) {
        return _updateOne.apply(this, arguments);
      }
      return updateOne;
    }()
  }, {
    key: "updateMany",
    value: function () {
      var _updateMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ids, data, query, options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.transport.patch("".concat(this.endpoint), {
                keys: ids,
                data: data
              }, _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 2:
              return _context7.abrupt("return", _context7.sent);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateMany(_x19, _x20, _x21, _x22) {
        return _updateMany.apply(this, arguments);
      }
      return updateMany;
    }()
  }, {
    key: "updateBatch",
    value: function () {
      var _updateBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(items, query, options) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.transport.patch("".concat(this.endpoint), items, _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateBatch(_x23, _x24, _x25) {
        return _updateBatch.apply(this, arguments);
      }
      return updateBatch;
    }()
  }, {
    key: "updateByQuery",
    value: function () {
      var _updateByQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(updateQuery, data, query, options) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.transport.patch("".concat(this.endpoint), {
                query: updateQuery,
                data: data
              }, _objectSpread({
                params: query
              }, options === null || options === void 0 ? void 0 : options.requestOptions));
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function updateByQuery(_x26, _x27, _x28, _x29) {
        return _updateByQuery.apply(this, arguments);
      }
      return updateByQuery;
    }()
  }, {
    key: "deleteOne",
    value: function () {
      var _deleteOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id, options) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!("".concat(id) === '')) {
                _context10.next = 2;
                break;
              }
              throw new EmptyParamError('id');
            case 2:
              _context10.next = 4;
              return this.transport.delete("".concat(this.endpoint, "/").concat(encodeURI(id)), undefined, options === null || options === void 0 ? void 0 : options.requestOptions);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function deleteOne(_x30, _x31) {
        return _deleteOne.apply(this, arguments);
      }
      return deleteOne;
    }()
  }, {
    key: "deleteMany",
    value: function () {
      var _deleteMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(ids, options) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.transport.delete("".concat(this.endpoint), ids, options === null || options === void 0 ? void 0 : options.requestOptions);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function deleteMany(_x32, _x33) {
        return _deleteMany.apply(this, arguments);
      }
      return deleteMany;
    }()
  }]);
  return ItemsHandler;
}();
var CommentsHandler = /*#__PURE__*/function () {
  function CommentsHandler(transport) {
    _classCallCheck(this, CommentsHandler);
    this.transport = transport;
  }
  _createClass(CommentsHandler, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(comment) {
        var response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.transport.post('/activity/comment', comment);
            case 2:
              response = _context12.sent;
              return _context12.abrupt("return", response.data);
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function create(_x34) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(comment_activity_id, comment) {
        var response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!("".concat(comment_activity_id) === '')) {
                _context13.next = 2;
                break;
              }
              throw new EmptyParamError('comment_activity_id');
            case 2:
              _context13.next = 4;
              return this.transport.patch("/activity/comment/".concat(encodeURI(comment_activity_id)), {
                comment: comment
              });
            case 4:
              response = _context13.sent;
              return _context13.abrupt("return", response.data);
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function update(_x35, _x36) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(comment_activity_id) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!("".concat(comment_activity_id) === '')) {
                _context14.next = 2;
                break;
              }
              throw new EmptyParamError('comment_activity_id');
            case 2:
              _context14.next = 4;
              return this.transport.delete("/activity/comment/".concat(encodeURI(comment_activity_id)));
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function _delete(_x37) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }]);
  return CommentsHandler;
}();
/**
 * Activity handler
 */
var ActivityHandler = /*#__PURE__*/function (_ItemsHandler) {
  _inherits(ActivityHandler, _ItemsHandler);
  var _super2 = _createSuper(ActivityHandler);
  function ActivityHandler(transport) {
    var _this;
    _classCallCheck(this, ActivityHandler);
    _this = _super2.call(this, 'directus_activity', transport);
    _this._comments = new CommentsHandler(_this.transport);
    return _this;
  }
  _createClass(ActivityHandler, [{
    key: "comments",
    get: function get() {
      return this._comments;
    }
  }]);
  return ActivityHandler;
}(ItemsHandler);
var AssetsHandler = /*#__PURE__*/function () {
  function AssetsHandler(transport) {
    _classCallCheck(this, AssetsHandler);
    this.transport = transport;
  }
  _createClass(AssetsHandler, [{
    key: "readOne",
    value: function () {
      var _readOne2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!("".concat(id) === '')) {
                _context15.next = 2;
                break;
              }
              throw new EmptyParamError('id');
            case 2:
              _context15.next = 4;
              return this.transport.get("/assets/".concat(id), {
                responseType: 'stream'
              });
            case 4:
              response = _context15.sent;
              return _context15.abrupt("return", response.raw);
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function readOne(_x38) {
        return _readOne2.apply(this, arguments);
      }
      return readOne;
    }()
  }]);
  return AssetsHandler;
}();
/**
 * Collections handler
 */
var CollectionsHandler = /*#__PURE__*/function () {
  function CollectionsHandler(transport) {
    _classCallCheck(this, CollectionsHandler);
    this.transport = transport;
  }
  _createClass(CollectionsHandler, [{
    key: "readOne",
    value: function () {
      var _readOne3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(collection) {
        var response;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context16.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              _context16.next = 4;
              return this.transport.get("/collections/".concat(collection));
            case 4:
              response = _context16.sent;
              return _context16.abrupt("return", response.data);
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function readOne(_x39) {
        return _readOne3.apply(this, arguments);
      }
      return readOne;
    }()
  }, {
    key: "readAll",
    value: function () {
      var _readAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _yield$this$transport3, data, meta;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.transport.get("/collections");
            case 2:
              _yield$this$transport3 = _context17.sent;
              data = _yield$this$transport3.data;
              meta = _yield$this$transport3.meta;
              return _context17.abrupt("return", {
                data: data,
                meta: meta
              });
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function readAll() {
        return _readAll.apply(this, arguments);
      }
      return readAll;
    }()
  }, {
    key: "createOne",
    value: function () {
      var _createOne2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(collection) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.transport.post("/collections", collection);
            case 2:
              return _context18.abrupt("return", _context18.sent.data);
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function createOne(_x40) {
        return _createOne2.apply(this, arguments);
      }
      return createOne;
    }()
  }, {
    key: "createMany",
    value: function () {
      var _createMany2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(collections) {
        var _yield$this$transport4, data, meta;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.transport.post("/collections", collections);
            case 2:
              _yield$this$transport4 = _context19.sent;
              data = _yield$this$transport4.data;
              meta = _yield$this$transport4.meta;
              return _context19.abrupt("return", {
                data: data,
                meta: meta
              });
            case 6:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function createMany(_x41) {
        return _createMany2.apply(this, arguments);
      }
      return createMany;
    }()
  }, {
    key: "updateOne",
    value: function () {
      var _updateOne2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(collection, item, query) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context20.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              _context20.next = 4;
              return this.transport.patch("/collections/".concat(collection), item, {
                params: query
              });
            case 4:
              return _context20.abrupt("return", _context20.sent.data);
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function updateOne(_x42, _x43, _x44) {
        return _updateOne2.apply(this, arguments);
      }
      return updateOne;
    }()
  }, {
    key: "deleteOne",
    value: function () {
      var _deleteOne2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(collection) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context21.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              _context21.next = 4;
              return this.transport.delete("/collections/".concat(collection));
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function deleteOne(_x45) {
        return _deleteOne2.apply(this, arguments);
      }
      return deleteOne;
    }()
  }]);
  return CollectionsHandler;
}();
/**
 * Fields handler
 */
var FieldsHandler = /*#__PURE__*/function () {
  function FieldsHandler(transport) {
    _classCallCheck(this, FieldsHandler);
    this.transport = transport;
  }
  _createClass(FieldsHandler, [{
    key: "readOne",
    value: function () {
      var _readOne4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(collection, id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context22.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              if (!("".concat(id) === '')) {
                _context22.next = 4;
                break;
              }
              throw new EmptyParamError('id');
            case 4:
              _context22.next = 6;
              return this.transport.get("/fields/".concat(collection, "/").concat(id));
            case 6:
              response = _context22.sent;
              return _context22.abrupt("return", response.data);
            case 8:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function readOne(_x46, _x47) {
        return _readOne4.apply(this, arguments);
      }
      return readOne;
    }()
  }, {
    key: "readMany",
    value: function () {
      var _readMany2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(collection) {
        var response;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context23.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              _context23.next = 4;
              return this.transport.get("/fields/".concat(collection));
            case 4:
              response = _context23.sent;
              return _context23.abrupt("return", {
                data: response.data,
                meta: undefined
              });
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function readMany(_x48) {
        return _readMany2.apply(this, arguments);
      }
      return readMany;
    }()
  }, {
    key: "readAll",
    value: function () {
      var _readAll2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var response;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return this.transport.get("/fields");
            case 2:
              response = _context24.sent;
              return _context24.abrupt("return", {
                data: response.data,
                meta: undefined
              });
            case 4:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function readAll() {
        return _readAll2.apply(this, arguments);
      }
      return readAll;
    }()
  }, {
    key: "createOne",
    value: function () {
      var _createOne3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(collection, item) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context25.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              _context25.next = 4;
              return this.transport.post("/fields/".concat(collection), item);
            case 4:
              return _context25.abrupt("return", _context25.sent.data);
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function createOne(_x49, _x50) {
        return _createOne3.apply(this, arguments);
      }
      return createOne;
    }()
  }, {
    key: "updateOne",
    value: function () {
      var _updateOne3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(collection, field, item) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context26.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              if (!("".concat(field) === '')) {
                _context26.next = 4;
                break;
              }
              throw new EmptyParamError('field');
            case 4:
              _context26.next = 6;
              return this.transport.patch("/fields/".concat(collection, "/").concat(field), item);
            case 6:
              return _context26.abrupt("return", _context26.sent.data);
            case 7:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function updateOne(_x51, _x52, _x53) {
        return _updateOne3.apply(this, arguments);
      }
      return updateOne;
    }()
  }, {
    key: "deleteOne",
    value: function () {
      var _deleteOne3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(collection, field) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context27.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              if (!("".concat(field) === '')) {
                _context27.next = 4;
                break;
              }
              throw new EmptyParamError('field');
            case 4:
              _context27.next = 6;
              return this.transport.delete("/fields/".concat(collection, "/").concat(field));
            case 6:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function deleteOne(_x54, _x55) {
        return _deleteOne3.apply(this, arguments);
      }
      return deleteOne;
    }()
  }]);
  return FieldsHandler;
}();
/**
 * Files handler
 */
var FilesHandler = /*#__PURE__*/function (_ItemsHandler2) {
  _inherits(FilesHandler, _ItemsHandler2);
  var _super3 = _createSuper(FilesHandler);
  function FilesHandler(transport) {
    _classCallCheck(this, FilesHandler);
    return _super3.call(this, 'directus_files', transport);
  }
  _createClass(FilesHandler, [{
    key: "import",
    value: function () {
      var _import2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(body) {
        var response;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return this.transport.post("/files/import", body);
            case 2:
              response = _context28.sent;
              return _context28.abrupt("return", response.data);
            case 4:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function _import(_x56) {
        return _import2.apply(this, arguments);
      }
      return _import;
    }()
  }]);
  return FilesHandler;
}(ItemsHandler);
/**
 * Folders handler
 */
var FoldersHandler = /*#__PURE__*/function (_ItemsHandler3) {
  _inherits(FoldersHandler, _ItemsHandler3);
  var _super4 = _createSuper(FoldersHandler);
  function FoldersHandler(transport) {
    _classCallCheck(this, FoldersHandler);
    return _super4.call(this, 'directus_folders', transport);
  }
  return _createClass(FoldersHandler);
}(ItemsHandler);
/**
 * Permissions handler
 */
var PermissionsHandler = /*#__PURE__*/function (_ItemsHandler4) {
  _inherits(PermissionsHandler, _ItemsHandler4);
  var _super5 = _createSuper(PermissionsHandler);
  function PermissionsHandler(transport) {
    _classCallCheck(this, PermissionsHandler);
    return _super5.call(this, 'directus_permissions', transport);
  }
  return _createClass(PermissionsHandler);
}(ItemsHandler);
/**
 * Presets handler
 */
var PresetsHandler = /*#__PURE__*/function (_ItemsHandler5) {
  _inherits(PresetsHandler, _ItemsHandler5);
  var _super6 = _createSuper(PresetsHandler);
  function PresetsHandler(transport) {
    _classCallCheck(this, PresetsHandler);
    return _super6.call(this, 'directus_presets', transport);
  }
  return _createClass(PresetsHandler);
}(ItemsHandler);
/**
 * Relations handler
 */
var RelationsHandler = /*#__PURE__*/function () {
  function RelationsHandler(transport) {
    _classCallCheck(this, RelationsHandler);
    this.transport = transport;
  }
  _createClass(RelationsHandler, [{
    key: "readOne",
    value: function () {
      var _readOne5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(collection, id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context29.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              if (!("".concat(id) === '')) {
                _context29.next = 4;
                break;
              }
              throw new EmptyParamError('id');
            case 4:
              _context29.next = 6;
              return this.transport.get("/relations/".concat(collection, "/").concat(id));
            case 6:
              response = _context29.sent;
              return _context29.abrupt("return", response.data);
            case 8:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function readOne(_x57, _x58) {
        return _readOne5.apply(this, arguments);
      }
      return readOne;
    }()
  }, {
    key: "readMany",
    value: function () {
      var _readMany3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(collection) {
        var response;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context30.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              _context30.next = 4;
              return this.transport.get("/relations/".concat(collection));
            case 4:
              response = _context30.sent;
              return _context30.abrupt("return", response.data);
            case 6:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function readMany(_x59) {
        return _readMany3.apply(this, arguments);
      }
      return readMany;
    }()
  }, {
    key: "readAll",
    value: function () {
      var _readAll3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var response;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return this.transport.get("/relations");
            case 2:
              response = _context31.sent;
              return _context31.abrupt("return", response.data);
            case 4:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function readAll() {
        return _readAll3.apply(this, arguments);
      }
      return readAll;
    }()
  }, {
    key: "createOne",
    value: function () {
      var _createOne4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(item) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return this.transport.post("/relations", item);
            case 2:
              return _context32.abrupt("return", _context32.sent.data);
            case 3:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function createOne(_x60) {
        return _createOne4.apply(this, arguments);
      }
      return createOne;
    }()
  }, {
    key: "updateOne",
    value: function () {
      var _updateOne4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(collection, field, item) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context33.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              if (!("".concat(field) === '')) {
                _context33.next = 4;
                break;
              }
              throw new EmptyParamError('field');
            case 4:
              _context33.next = 6;
              return this.transport.patch("/relations/".concat(collection, "/").concat(field), item);
            case 6:
              return _context33.abrupt("return", _context33.sent.data);
            case 7:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function updateOne(_x61, _x62, _x63) {
        return _updateOne4.apply(this, arguments);
      }
      return updateOne;
    }()
  }, {
    key: "deleteOne",
    value: function () {
      var _deleteOne4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(collection, field) {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!("".concat(collection) === '')) {
                _context34.next = 2;
                break;
              }
              throw new EmptyParamError('collection');
            case 2:
              if (!("".concat(field) === '')) {
                _context34.next = 4;
                break;
              }
              throw new EmptyParamError('field');
            case 4:
              _context34.next = 6;
              return this.transport.delete("/relations/".concat(collection, "/").concat(field));
            case 6:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function deleteOne(_x64, _x65) {
        return _deleteOne4.apply(this, arguments);
      }
      return deleteOne;
    }()
  }]);
  return RelationsHandler;
}();
/**
 * Revisions handler
 */
var RevisionsHandler = /*#__PURE__*/function (_ItemsHandler6) {
  _inherits(RevisionsHandler, _ItemsHandler6);
  var _super7 = _createSuper(RevisionsHandler);
  function RevisionsHandler(transport) {
    _classCallCheck(this, RevisionsHandler);
    return _super7.call(this, 'directus_revisions', transport);
  }
  return _createClass(RevisionsHandler);
}(ItemsHandler);
/**
 * Roles handler
 */
var RolesHandler = /*#__PURE__*/function (_ItemsHandler7) {
  _inherits(RolesHandler, _ItemsHandler7);
  var _super8 = _createSuper(RolesHandler);
  function RolesHandler(transport) {
    _classCallCheck(this, RolesHandler);
    return _super8.call(this, 'directus_roles', transport);
  }
  return _createClass(RolesHandler);
}(ItemsHandler);
/**
 * Server handler
 */
var ServerHandler = /*#__PURE__*/function () {
  function ServerHandler(transport) {
    _classCallCheck(this, ServerHandler);
    this.transport = transport;
  }
  _createClass(ServerHandler, [{
    key: "ping",
    value: function () {
      var _ping = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return this.transport.get('/server/ping');
            case 2:
              return _context35.abrupt("return", _context35.sent.raw);
            case 3:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function ping() {
        return _ping.apply(this, arguments);
      }
      return ping;
    }()
  }, {
    key: "info",
    value: function () {
      var _info = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return this.transport.get('/server/info');
            case 2:
              return _context36.abrupt("return", _context36.sent.data);
            case 3:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function info() {
        return _info.apply(this, arguments);
      }
      return info;
    }()
  }, {
    key: "oas",
    value: function () {
      var _oas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return this.transport.get('/server/specs/oas');
            case 2:
              return _context37.abrupt("return", _context37.sent.raw);
            case 3:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function oas() {
        return _oas.apply(this, arguments);
      }
      return oas;
    }()
  }]);
  return ServerHandler;
}();
var SingletonHandler = /*#__PURE__*/function () {
  function SingletonHandler(collection, transport) {
    _classCallCheck(this, SingletonHandler);
    this.collection = collection;
    this.transport = transport;
    this.endpoint = collection.startsWith('directus_') ? "/".concat(collection.substring(9)) : "/items/".concat(collection);
  }
  _createClass(SingletonHandler, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(query) {
        var item;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return this.transport.get("".concat(this.endpoint), {
                params: query
              });
            case 2:
              item = _context38.sent;
              return _context38.abrupt("return", item.data);
            case 4:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function read(_x66) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "update",
    value: function () {
      var _update2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(data, _query) {
        var item;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return this.transport.patch("".concat(this.endpoint), data, {
                params: _query
              });
            case 2:
              item = _context39.sent;
              return _context39.abrupt("return", item.data);
            case 4:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this);
      }));
      function update(_x67, _x68) {
        return _update2.apply(this, arguments);
      }
      return update;
    }()
  }]);
  return SingletonHandler;
}();
var SettingsHandler = /*#__PURE__*/function (_SingletonHandler) {
  _inherits(SettingsHandler, _SingletonHandler);
  var _super9 = _createSuper(SettingsHandler);
  function SettingsHandler(transport) {
    _classCallCheck(this, SettingsHandler);
    return _super9.call(this, 'directus_settings', transport);
  }
  return _createClass(SettingsHandler);
}(SingletonHandler);
var InvitesHandler = /*#__PURE__*/function () {
  function InvitesHandler(transport) {
    _classCallCheck(this, InvitesHandler);
    this.transport = transport;
  }
  _createClass(InvitesHandler, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(email, role, invite_url) {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return this.transport.post('/users/invite', {
                email: email,
                role: role,
                invite_url: invite_url
              });
            case 2:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
      function send(_x69, _x70, _x71) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "accept",
    value: function () {
      var _accept = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(token, password) {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return this.transport.post("/users/invite/accept", {
                token: token,
                password: password
              });
            case 2:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
      function accept(_x72, _x73) {
        return _accept.apply(this, arguments);
      }
      return accept;
    }()
  }]);
  return InvitesHandler;
}();
var TFAHandler = /*#__PURE__*/function () {
  function TFAHandler(transport) {
    _classCallCheck(this, TFAHandler);
    this.transport = transport;
  }
  _createClass(TFAHandler, [{
    key: "generate",
    value: function () {
      var _generate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(password) {
        var result;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return this.transport.post('/users/me/tfa/generate', {
                password: password
              });
            case 2:
              result = _context42.sent;
              return _context42.abrupt("return", result.data);
            case 4:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
      function generate(_x74) {
        return _generate.apply(this, arguments);
      }
      return generate;
    }()
  }, {
    key: "enable",
    value: function () {
      var _enable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(secret, otp) {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.transport.post('/users/me/tfa/enable', {
                secret: secret,
                otp: otp
              });
            case 2:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this);
      }));
      function enable(_x75, _x76) {
        return _enable.apply(this, arguments);
      }
      return enable;
    }()
  }, {
    key: "disable",
    value: function () {
      var _disable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(otp) {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return this.transport.post('/users/me/tfa/disable', {
                otp: otp
              });
            case 2:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function disable(_x77) {
        return _disable.apply(this, arguments);
      }
      return disable;
    }()
  }]);
  return TFAHandler;
}();
var MeHandler = /*#__PURE__*/function () {
  function MeHandler(transport) {
    _classCallCheck(this, MeHandler);
    this._transport = transport;
  }
  _createClass(MeHandler, [{
    key: "tfa",
    get: function get() {
      return this._tfa || (this._tfa = new TFAHandler(this._transport));
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(query) {
        var response;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return this._transport.get('/users/me', {
                params: query
              });
            case 2:
              response = _context45.sent;
              return _context45.abrupt("return", response.data);
            case 4:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
      function read(_x78) {
        return _read2.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "update",
    value: function () {
      var _update3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(data, query) {
        var response;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return this._transport.patch("/users/me", data, {
                params: query
              });
            case 2:
              response = _context46.sent;
              return _context46.abrupt("return", response.data);
            case 4:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function update(_x79, _x80) {
        return _update3.apply(this, arguments);
      }
      return update;
    }()
  }]);
  return MeHandler;
}();
/**
 * Users handler
 */
var UsersHandler = /*#__PURE__*/function (_ItemsHandler8) {
  _inherits(UsersHandler, _ItemsHandler8);
  var _super10 = _createSuper(UsersHandler);
  function UsersHandler(transport) {
    _classCallCheck(this, UsersHandler);
    return _super10.call(this, 'directus_users', transport);
  }
  _createClass(UsersHandler, [{
    key: "invites",
    get: function get() {
      return this._invites || (this._invites = new InvitesHandler(this.transport));
    }
  }, {
    key: "me",
    get: function get() {
      return this._me || (this._me = new MeHandler(this.transport));
    }
  }]);
  return UsersHandler;
}(ItemsHandler);
/**
 * Utils handler
 */
var UtilsHandler = /*#__PURE__*/function () {
  function UtilsHandler(transport) {
    var _this2 = this;
    _classCallCheck(this, UtilsHandler);
    this.random = {
      string: function () {
        var _string = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
          var length,
            result,
            _args47 = arguments;
          return _regeneratorRuntime.wrap(function _callee47$(_context47) {
            while (1) switch (_context47.prev = _context47.next) {
              case 0:
                length = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : 32;
                _context47.next = 3;
                return _this2.transport.get('/utils/random/string', {
                  params: {
                    length: length
                  }
                });
              case 3:
                result = _context47.sent;
                return _context47.abrupt("return", result.data);
              case 5:
              case "end":
                return _context47.stop();
            }
          }, _callee47);
        }));
        function string() {
          return _string.apply(this, arguments);
        }
        return string;
      }()
    };
    this.hash = {
      generate: function () {
        var _generate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(string) {
          var result;
          return _regeneratorRuntime.wrap(function _callee48$(_context48) {
            while (1) switch (_context48.prev = _context48.next) {
              case 0:
                _context48.next = 2;
                return _this2.transport.post('/utils/hash/generate', {
                  string: string
                });
              case 2:
                result = _context48.sent;
                return _context48.abrupt("return", result.data);
              case 4:
              case "end":
                return _context48.stop();
            }
          }, _callee48);
        }));
        function generate(_x81) {
          return _generate2.apply(this, arguments);
        }
        return generate;
      }(),
      verify: function () {
        var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(string, hash) {
          var result;
          return _regeneratorRuntime.wrap(function _callee49$(_context49) {
            while (1) switch (_context49.prev = _context49.next) {
              case 0:
                _context49.next = 2;
                return _this2.transport.post('/utils/hash/verify', {
                  string: string,
                  hash: hash
                });
              case 2:
                result = _context49.sent;
                return _context49.abrupt("return", result.data);
              case 4:
              case "end":
                return _context49.stop();
            }
          }, _callee49);
        }));
        function verify(_x82, _x83) {
          return _verify.apply(this, arguments);
        }
        return verify;
      }()
    };
    this.transport = transport;
  }
  _createClass(UtilsHandler, [{
    key: "sort",
    value: function () {
      var _sort = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(collection, item, to) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              _context50.next = 2;
              return this.transport.post("/utils/sort/".concat(encodeURI(collection)), {
                item: item,
                to: to
              });
            case 2:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function sort(_x84, _x85, _x86) {
        return _sort.apply(this, arguments);
      }
      return sort;
    }()
  }, {
    key: "revert",
    value: function () {
      var _revert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(revision) {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _context51.next = 2;
              return this.transport.post("/utils/revert/".concat(encodeURI(revision)));
            case 2:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this);
      }));
      function revert(_x87) {
        return _revert.apply(this, arguments);
      }
      return revert;
    }()
  }]);
  return UtilsHandler;
}();
var IStorage = /*#__PURE__*/_createClass(function IStorage() {
  _classCallCheck(this, IStorage);
});
var ITransport = /*#__PURE__*/_createClass(function ITransport() {
  _classCallCheck(this, ITransport);
});
var TransportError = /*#__PURE__*/function (_Error2) {
  _inherits(TransportError, _Error2);
  var _super11 = _createSuper(TransportError);
  function TransportError(parent, response) {
    var _this3;
    _classCallCheck(this, TransportError);
    var _a, _b;
    if ((_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.length) {
      _this3 = _super11.call(this, (_b = response === null || response === void 0 ? void 0 : response.errors[0]) === null || _b === void 0 ? void 0 : _b.message);
    } else {
      _this3 = _super11.call(this, (parent === null || parent === void 0 ? void 0 : parent.message) || 'Unknown transport error');
    }
    _this3.parent = parent;
    _this3.response = response;
    _this3.errors = (response === null || response === void 0 ? void 0 : response.errors) || [];
    if (!Object.values(response || {}).some(function (value) {
      return value !== undefined;
    })) {
      _this3.response = undefined;
    }
    Object.setPrototypeOf(_assertThisInitialized(_this3), TransportError.prototype);
    return _possibleConstructorReturn(_this3);
  }
  return _createClass(TransportError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var Keys;
(function (Keys) {
  Keys["AuthToken"] = "auth_token";
  Keys["RefreshToken"] = "auth_refresh_token";
  Keys["Expires"] = "auth_expires";
  Keys["ExpiresAt"] = "auth_expires_at";
})(Keys || (Keys = {}));
var BaseStorage = /*#__PURE__*/function (_IStorage) {
  _inherits(BaseStorage, _IStorage);
  var _super12 = _createSuper(BaseStorage);
  function BaseStorage(options) {
    var _this4;
    _classCallCheck(this, BaseStorage);
    var _a;
    _this4 = _super12.call(this);
    _this4.prefix = (_a = options === null || options === void 0 ? void 0 : options.prefix) !== null && _a !== void 0 ? _a : '';
    return _this4;
  }
  _createClass(BaseStorage, [{
    key: "auth_token",
    get: function get() {
      return this.get(Keys.AuthToken);
    },
    set: function set(value) {
      if (value === null) {
        this.delete(Keys.AuthToken);
      } else {
        this.set(Keys.AuthToken, value);
      }
    }
  }, {
    key: "auth_expires",
    get: function get() {
      var value = this.get(Keys.Expires);
      if (value === null) {
        return null;
      }
      return parseInt(value);
    },
    set: function set(value) {
      if (value === null) {
        this.delete(Keys.Expires);
      } else {
        this.set(Keys.Expires, value.toString());
      }
    }
  }, {
    key: "auth_expires_at",
    get: function get() {
      var value = this.get(Keys.ExpiresAt);
      if (value === null) {
        return null;
      }
      return parseInt(value);
    },
    set: function set(value) {
      if (value === null) {
        this.delete(Keys.ExpiresAt);
      } else {
        this.set(Keys.ExpiresAt, value.toString());
      }
    }
  }, {
    key: "auth_refresh_token",
    get: function get() {
      return this.get(Keys.RefreshToken);
    },
    set: function set(value) {
      if (value === null) {
        this.delete(Keys.RefreshToken);
      } else {
        this.set(Keys.RefreshToken, value);
      }
    }
  }]);
  return BaseStorage;
}(IStorage);
var MemoryStorage = /*#__PURE__*/function (_BaseStorage) {
  _inherits(MemoryStorage, _BaseStorage);
  var _super13 = _createSuper(MemoryStorage);
  function MemoryStorage() {
    var _this5;
    _classCallCheck(this, MemoryStorage);
    _this5 = _super13.apply(this, arguments);
    _this5.values = {};
    return _this5;
  }
  _createClass(MemoryStorage, [{
    key: "get",
    value: function get(key) {
      var k = this.key(key);
      if (k in this.values) {
        return this.values[k];
      }
      return null;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.values[this.key(key)] = value;
      return value;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var value = this.get(key);
      delete this.values[this.key(key)];
      return value;
    }
  }, {
    key: "key",
    value: function key(name) {
      return "".concat(this.prefix).concat(name);
    }
  }]);
  return MemoryStorage;
}(BaseStorage);
var LocalStorage = /*#__PURE__*/function (_BaseStorage2) {
  _inherits(LocalStorage, _BaseStorage2);
  var _super14 = _createSuper(LocalStorage);
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
    return _super14.apply(this, arguments);
  }
  _createClass(LocalStorage, [{
    key: "get",
    value: function get(key) {
      var value = localStorage.getItem(this.key(key));
      if (value !== null) {
        return value;
      }
      return null;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      localStorage.setItem(this.key(key), value);
      return value;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var value = this.get(key);
      localStorage.removeItem(this.key(key));
      return value;
    }
  }, {
    key: "key",
    value: function key(name) {
      return "".concat(this.prefix).concat(name);
    }
  }]);
  return LocalStorage;
}(BaseStorage);
/**
 * Transport implementation
 */
var Transport = /*#__PURE__*/function (_ITransport) {
  _inherits(Transport, _ITransport);
  var _super15 = _createSuper(Transport);
  function Transport(config) {
    var _this6;
    _classCallCheck(this, Transport);
    var _a;
    _this6 = _super15.call(this);
    _this6.config = config;
    _this6.axios = axios.create({
      baseURL: _this6.config.url,
      params: _this6.config.params,
      headers: _this6.config.headers,
      onUploadProgress: _this6.config.onUploadProgress,
      maxBodyLength: _this6.config.maxBodyLength,
      maxContentLength: _this6.config.maxContentLength,
      withCredentials: true
    });
    if ((_a = _this6.config) === null || _a === void 0 ? void 0 : _a.beforeRequest) _this6.beforeRequest = _this6.config.beforeRequest;
    return _this6;
  }
  _createClass(Transport, [{
    key: "beforeRequest",
    value: function () {
      var _beforeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(config) {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              return _context52.abrupt("return", config);
            case 1:
            case "end":
              return _context52.stop();
          }
        }, _callee52);
      }));
      function beforeRequest(_x88) {
        return _beforeRequest.apply(this, arguments);
      }
      return beforeRequest;
    }()
  }, {
    key: "url",
    get: function get() {
      return this.config.url;
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(method, path, data, options) {
        var _a, _b, _c, _d, _e, config, response, content, _data;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _context53.prev = 0;
              config = {
                method: method,
                url: path,
                data: data,
                params: options === null || options === void 0 ? void 0 : options.params,
                headers: options === null || options === void 0 ? void 0 : options.headers,
                responseType: options === null || options === void 0 ? void 0 : options.responseType,
                onUploadProgress: options === null || options === void 0 ? void 0 : options.onUploadProgress
              };
              _context53.next = 4;
              return this.beforeRequest(config);
            case 4:
              config = _context53.sent;
              _context53.next = 7;
              return this.axios.request(config);
            case 7:
              response = _context53.sent;
              content = {
                raw: response.data,
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
                data: response.data.data,
                meta: response.data.meta,
                errors: response.data.errors
              };
              if (!response.data.errors) {
                _context53.next = 11;
                break;
              }
              throw new TransportError(null, content);
            case 11:
              return _context53.abrupt("return", content);
            case 14:
              _context53.prev = 14;
              _context53.t0 = _context53["catch"](0);
              if (!(!_context53.t0 || _context53.t0 instanceof Error === false)) {
                _context53.next = 18;
                break;
              }
              throw _context53.t0;
            case 18:
              if (!axios.isAxiosError(_context53.t0)) {
                _context53.next = 21;
                break;
              }
              _data = (_a = _context53.t0.response) === null || _a === void 0 ? void 0 : _a.data;
              throw new TransportError(_context53.t0, {
                raw: (_b = _context53.t0.response) === null || _b === void 0 ? void 0 : _b.data,
                status: (_c = _context53.t0.response) === null || _c === void 0 ? void 0 : _c.status,
                statusText: (_d = _context53.t0.response) === null || _d === void 0 ? void 0 : _d.statusText,
                headers: (_e = _context53.t0.response) === null || _e === void 0 ? void 0 : _e.headers,
                data: _data === null || _data === void 0 ? void 0 : _data.data,
                meta: _data === null || _data === void 0 ? void 0 : _data.meta,
                errors: _data === null || _data === void 0 ? void 0 : _data.errors
              });
            case 21:
              throw new TransportError(_context53.t0);
            case 22:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this, [[0, 14]]);
      }));
      function request(_x89, _x90, _x91, _x92) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(path, options) {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 2;
              return this.request('get', path, undefined, options);
            case 2:
              return _context54.abrupt("return", _context54.sent);
            case 3:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function get(_x93, _x94) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "head",
    value: function () {
      var _head = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(path, options) {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _context55.next = 2;
              return this.request('head', path, undefined, options);
            case 2:
              return _context55.abrupt("return", _context55.sent);
            case 3:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this);
      }));
      function head(_x95, _x96) {
        return _head.apply(this, arguments);
      }
      return head;
    }()
  }, {
    key: "options",
    value: function () {
      var _options2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(path, _options) {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return this.request('options', path, undefined, _options);
            case 2:
              return _context56.abrupt("return", _context56.sent);
            case 3:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
      function options(_x97, _x98) {
        return _options2.apply(this, arguments);
      }
      return options;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              _context57.next = 2;
              return this.request('delete', path, data, options);
            case 2:
              return _context57.abrupt("return", _context57.sent);
            case 3:
            case "end":
              return _context57.stop();
          }
        }, _callee57, this);
      }));
      function _delete(_x99, _x100, _x101) {
        return _delete3.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              _context58.next = 2;
              return this.request('put', path, data, options);
            case 2:
              return _context58.abrupt("return", _context58.sent);
            case 3:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
      function put(_x102, _x103, _x104) {
        return _put.apply(this, arguments);
      }
      return put;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return this.request('post', path, data, options);
            case 2:
              return _context59.abrupt("return", _context59.sent);
            case 3:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this);
      }));
      function post(_x105, _x106, _x107) {
        return _post.apply(this, arguments);
      }
      return post;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return this.request('patch', path, data, options);
            case 2:
              return _context60.abrupt("return", _context60.sent);
            case 3:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this);
      }));
      function patch(_x108, _x109, _x110) {
        return _patch.apply(this, arguments);
      }
      return patch;
    }()
  }]);
  return Transport;
}(ITransport);
var PasswordsHandler = /*#__PURE__*/function () {
  function PasswordsHandler(transport) {
    _classCallCheck(this, PasswordsHandler);
    this.transport = transport;
  }
  _createClass(PasswordsHandler, [{
    key: "request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(email, reset_url) {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              _context61.next = 2;
              return this.transport.post('/auth/password/request', {
                email: email,
                reset_url: reset_url
              });
            case 2:
            case "end":
              return _context61.stop();
          }
        }, _callee61, this);
      }));
      function request(_x111, _x112) {
        return _request2.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(token, password) {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              _context62.next = 2;
              return this.transport.post('/auth/password/reset', {
                token: token,
                password: password
              });
            case 2:
            case "end":
              return _context62.stop();
          }
        }, _callee62, this);
      }));
      function reset(_x113, _x114) {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }]);
  return PasswordsHandler;
}();
var Auth = /*#__PURE__*/function (_IAuth) {
  _inherits(Auth, _IAuth);
  var _super16 = _createSuper(Auth);
  function Auth(options) {
    var _this7;
    _classCallCheck(this, Auth);
    var _a, _b, _c;
    _this7 = _super16.call(this);
    _this7.autoRefresh = true;
    _this7.msRefreshBeforeExpires = 30000;
    _this7.staticToken = '';
    _this7._transport = options.transport;
    _this7._storage = options.storage;
    _this7.autoRefresh = (_a = options === null || options === void 0 ? void 0 : options.autoRefresh) !== null && _a !== void 0 ? _a : _this7.autoRefresh;
    _this7.mode = (_b = options === null || options === void 0 ? void 0 : options.mode) !== null && _b !== void 0 ? _b : _this7.mode;
    _this7.msRefreshBeforeExpires = (_c = options === null || options === void 0 ? void 0 : options.msRefreshBeforeExpires) !== null && _c !== void 0 ? _c : _this7.msRefreshBeforeExpires;
    if (options === null || options === void 0 ? void 0 : options.staticToken) {
      _this7.staticToken = options === null || options === void 0 ? void 0 : options.staticToken;
      _this7.updateStorage({
        access_token: _this7.staticToken,
        expires: null,
        refresh_token: null
      });
    }
    return _this7;
  }
  _createClass(Auth, [{
    key: "storage",
    get: function get() {
      return this._storage;
    }
  }, {
    key: "transport",
    get: function get() {
      return this._transport;
    }
  }, {
    key: "token",
    get: function get() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (!_this8._refreshPromise) {
                _context63.next = 7;
                break;
              }
              _context63.prev = 1;
              _context63.next = 4;
              return _this8._refreshPromise;
            case 4:
              _context63.prev = 4;
              _this8._refreshPromise = undefined;
              return _context63.finish(4);
            case 7:
              return _context63.abrupt("return", _this8._storage.auth_token);
            case 8:
            case "end":
              return _context63.stop();
          }
        }, _callee63, null, [[1,, 4, 7]]);
      }))();
    }
  }, {
    key: "password",
    get: function get() {
      return this.passwords = this.passwords || new PasswordsHandler(this._transport);
    }
  }, {
    key: "resetStorage",
    value: function resetStorage() {
      this._storage.auth_token = null;
      this._storage.auth_refresh_token = null;
      this._storage.auth_expires = null;
      this._storage.auth_expires_at = null;
    }
  }, {
    key: "updateStorage",
    value: function updateStorage(result) {
      var _a, _b;
      var expires = (_a = result.expires) !== null && _a !== void 0 ? _a : null;
      this._storage.auth_token = result.access_token;
      this._storage.auth_refresh_token = (_b = result.refresh_token) !== null && _b !== void 0 ? _b : null;
      this._storage.auth_expires = expires;
      this._storage.auth_expires_at = new Date().getTime() + (expires !== null && expires !== void 0 ? expires : 0);
    }
  }, {
    key: "refreshIfExpired",
    value: function () {
      var _refreshIfExpired = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              if (!this.staticToken) {
                _context64.next = 2;
                break;
              }
              return _context64.abrupt("return");
            case 2:
              if (this.autoRefresh) {
                _context64.next = 4;
                break;
              }
              return _context64.abrupt("return");
            case 4:
              if (this._storage.auth_expires_at) {
                _context64.next = 12;
                break;
              }
              _context64.prev = 5;
              _context64.next = 8;
              return this._refreshPromise;
            case 8:
              _context64.prev = 8;
              this._refreshPromise = undefined;
              return _context64.finish(8);
            case 11:
              return _context64.abrupt("return");
            case 12:
              if (this._storage.auth_expires_at < new Date().getTime() + this.msRefreshBeforeExpires) {
                this.refresh();
              }
              _context64.prev = 13;
              _context64.next = 16;
              return this._refreshPromise;
            case 16:
              _context64.prev = 16;
              this._refreshPromise = undefined;
              return _context64.finish(16);
            case 19:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this, [[5,, 8, 11], [13,, 16, 19]]);
      }));
      function refreshIfExpired() {
        return _refreshIfExpired.apply(this, arguments);
      }
      return refreshIfExpired;
    }()
  }, {
    key: "refresh",
    value: function refresh() {
      var _this9 = this;
      var refreshPromise = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
          var _a, refresh_token, response;
          return _regeneratorRuntime.wrap(function _callee65$(_context65) {
            while (1) switch (_context65.prev = _context65.next) {
              case 0:
                refresh_token = _this9._storage.auth_refresh_token;
                _this9.resetStorage();
                _context65.next = 4;
                return _this9._transport.post('/auth/refresh', {
                  refresh_token: _this9.mode === 'json' ? refresh_token : undefined
                });
              case 4:
                response = _context65.sent;
                _this9.updateStorage(response.data);
                return _context65.abrupt("return", _objectSpread(_objectSpread({
                  access_token: response.data.access_token
                }, ((_a = response.data) === null || _a === void 0 ? void 0 : _a.refresh_token) && {
                  refresh_token: response.data.refresh_token
                }), {}, {
                  expires: response.data.expires
                }));
              case 7:
              case "end":
                return _context65.stop();
            }
          }, _callee65);
        }));
        return function refreshPromise() {
          return _ref2.apply(this, arguments);
        };
      }();
      return this._refreshPromise = refreshPromise();
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(credentials) {
        var _a, response;
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              this.resetStorage();
              _context66.next = 3;
              return this._transport.post('/auth/login', _objectSpread({
                mode: this.mode
              }, credentials), {
                headers: {
                  Authorization: null
                }
              });
            case 3:
              response = _context66.sent;
              this.updateStorage(response.data);
              return _context66.abrupt("return", _objectSpread(_objectSpread({
                access_token: response.data.access_token
              }, ((_a = response.data) === null || _a === void 0 ? void 0 : _a.refresh_token) && {
                refresh_token: response.data.refresh_token
              }), {}, {
                expires: response.data.expires
              }));
            case 6:
            case "end":
              return _context66.stop();
          }
        }, _callee66, this);
      }));
      function login(_x115) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "static",
    value: function () {
      var _static2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(token) {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              if (!this.staticToken) this.staticToken = token;
              _context67.next = 3;
              return this._transport.get('/users/me', {
                params: {
                  access_token: token
                },
                headers: {
                  Authorization: null
                }
              });
            case 3:
              this.updateStorage({
                access_token: token,
                expires: null,
                refresh_token: null
              });
              return _context67.abrupt("return", true);
            case 5:
            case "end":
              return _context67.stop();
          }
        }, _callee67, this);
      }));
      function _static(_x116) {
        return _static2.apply(this, arguments);
      }
      return _static;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68() {
        var refresh_token;
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              if (this.mode === 'json') {
                refresh_token = this._storage.auth_refresh_token || undefined;
              }
              _context68.next = 3;
              return this._transport.post('/auth/logout', {
                refresh_token: refresh_token
              });
            case 3:
              this.updateStorage({
                access_token: null,
                expires: null,
                refresh_token: null
              });
            case 4:
            case "end":
              return _context68.stop();
          }
        }, _callee68, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }]);
  return Auth;
}(IAuth);
var GraphQLHandler = /*#__PURE__*/function () {
  function GraphQLHandler(transport) {
    _classCallCheck(this, GraphQLHandler);
    this.transport = transport;
  }
  _createClass(GraphQLHandler, [{
    key: "request",
    value: function () {
      var _request3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(base, query, variables) {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              _context69.next = 2;
              return this.transport.post(base, {
                query: query,
                variables: typeof variables === 'undefined' ? {} : variables
              });
            case 2:
              return _context69.abrupt("return", _context69.sent);
            case 3:
            case "end":
              return _context69.stop();
          }
        }, _callee69, this);
      }));
      function request(_x117, _x118, _x119) {
        return _request3.apply(this, arguments);
      }
      return request;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  }, {
    key: "items",
    value: function () {
      var _items = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(query, variables) {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _context70.next = 2;
              return this.request('/graphql', query, variables);
            case 2:
              return _context70.abrupt("return", _context70.sent);
            case 3:
            case "end":
              return _context70.stop();
          }
        }, _callee70, this);
      }));
      function items(_x120, _x121) {
        return _items.apply(this, arguments);
      }
      return items;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  }, {
    key: "system",
    value: function () {
      var _system = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(query, variables) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              _context71.next = 2;
              return this.request('/graphql/system', query, variables);
            case 2:
              return _context71.abrupt("return", _context71.sent);
            case 3:
            case "end":
              return _context71.stop();
          }
        }, _callee71, this);
      }));
      function system(_x122, _x123) {
        return _system.apply(this, arguments);
      }
      return system;
    }()
  }]);
  return GraphQLHandler;
}();
/* eslint-disable prettier/prettier */
var Directus = /*#__PURE__*/function () {
  function Directus(url, options) {
    var _this10 = this;
    _classCallCheck(this, Directus);
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    this._url = url;
    this._options = options;
    this._items = {};
    this._singletons = {};
    if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.storage) && ((_b = this._options) === null || _b === void 0 ? void 0 : _b.storage) instanceof IStorage) this._storage = this._options.storage;else {
      var directusStorageOptions = (_c = this._options) === null || _c === void 0 ? void 0 : _c.storage;
      var _ref3 = directusStorageOptions !== null && directusStorageOptions !== void 0 ? directusStorageOptions : {},
        mode = _ref3.mode,
        storageOptions = _objectWithoutProperties(_ref3, _excluded);
      if (mode === 'MemoryStorage' || typeof window === 'undefined') {
        this._storage = new MemoryStorage(storageOptions);
      } else {
        this._storage = new LocalStorage(storageOptions);
      }
    }
    if (((_d = this._options) === null || _d === void 0 ? void 0 : _d.transport) && ((_e = this._options) === null || _e === void 0 ? void 0 : _e.transport) instanceof ITransport) this._transport = this._options.transport;else {
      this._transport = new Transport(_objectSpread(_objectSpread({
        url: this.url
      }, (_f = this._options) === null || _f === void 0 ? void 0 : _f.transport), {}, {
        beforeRequest: function () {
          var _beforeRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(config) {
            var _a, _b, _c, _d, _e, _f, token, bearer, authenticatedConfig;
            return _regeneratorRuntime.wrap(function _callee72$(_context72) {
              while (1) switch (_context72.prev = _context72.next) {
                case 0:
                  if (!(_this10._url.indexOf('/auth/refresh') === -1 && ((_a = config.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'post')) {
                    _context72.next = 3;
                    break;
                  }
                  _context72.next = 3;
                  return _this10._auth.refreshIfExpired();
                case 3:
                  token = _this10.storage.auth_token;
                  bearer = token ? token.startsWith("Bearer ") ? String(_this10.storage.auth_token) : "Bearer ".concat(_this10.storage.auth_token) : '';
                  authenticatedConfig = _objectSpread(_objectSpread({}, config), {}, {
                    headers: _objectSpread({
                      Authorization: bearer
                    }, config.headers)
                  });
                  if (!(!(((_b = _this10._options) === null || _b === void 0 ? void 0 : _b.transport) instanceof ITransport) && ((_d = (_c = _this10._options) === null || _c === void 0 ? void 0 : _c.transport) === null || _d === void 0 ? void 0 : _d.beforeRequest))) {
                    _context72.next = 8;
                    break;
                  }
                  return _context72.abrupt("return", (_f = (_e = _this10._options) === null || _e === void 0 ? void 0 : _e.transport) === null || _f === void 0 ? void 0 : _f.beforeRequest(authenticatedConfig));
                case 8:
                  return _context72.abrupt("return", authenticatedConfig);
                case 9:
                case "end":
                  return _context72.stop();
              }
            }, _callee72);
          }));
          function beforeRequest(_x124) {
            return _beforeRequest2.apply(this, arguments);
          }
          return beforeRequest;
        }()
      }));
    }
    if (((_g = this._options) === null || _g === void 0 ? void 0 : _g.auth) && ((_h = this._options) === null || _h === void 0 ? void 0 : _h.auth) instanceof IAuth) this._auth = this._options.auth;else this._auth = new Auth(_objectSpread({
      transport: this._transport,
      storage: this._storage
    }, (_j = this._options) === null || _j === void 0 ? void 0 : _j.auth));
  }
  _createClass(Directus, [{
    key: "url",
    get: function get() {
      return this._url;
    }
  }, {
    key: "auth",
    get: function get() {
      return this._auth;
    }
  }, {
    key: "storage",
    get: function get() {
      return this._storage;
    }
  }, {
    key: "transport",
    get: function get() {
      return this._transport;
    }
  }, {
    key: "assets",
    get: function get() {
      return this._assets || (this._assets = new AssetsHandler(this.transport));
    }
  }, {
    key: "activity",
    get: function get() {
      return this._activity || (this._activity = new ActivityHandler(this.transport));
    }
  }, {
    key: "collections",
    get: function get() {
      return this._collections || (this._collections = new CollectionsHandler(this.transport));
    }
  }, {
    key: "fields",
    get: function get() {
      return this._fields || (this._fields = new FieldsHandler(this.transport));
    }
  }, {
    key: "files",
    get: function get() {
      return this._files || (this._files = new FilesHandler(this.transport));
    }
  }, {
    key: "folders",
    get: function get() {
      return this._folders || (this._folders = new FoldersHandler(this.transport));
    }
  }, {
    key: "permissions",
    get: function get() {
      return this._permissions || (this._permissions = new PermissionsHandler(this.transport));
    }
  }, {
    key: "presets",
    get: function get() {
      return this._presets || (this._presets = new PresetsHandler(this.transport));
    }
  }, {
    key: "relations",
    get: function get() {
      return this._relations || (this._relations = new RelationsHandler(this.transport));
    }
  }, {
    key: "revisions",
    get: function get() {
      return this._revisions || (this._revisions = new RevisionsHandler(this.transport));
    }
  }, {
    key: "roles",
    get: function get() {
      return this._roles || (this._roles = new RolesHandler(this.transport));
    }
  }, {
    key: "users",
    get: function get() {
      return this._users || (this._users = new UsersHandler(this.transport));
    }
  }, {
    key: "settings",
    get: function get() {
      return this._settings || (this._settings = new SettingsHandler(this.transport));
    }
  }, {
    key: "server",
    get: function get() {
      return this._server || (this._server = new ServerHandler(this.transport));
    }
  }, {
    key: "utils",
    get: function get() {
      return this._utils || (this._utils = new UtilsHandler(this.transport));
    }
  }, {
    key: "graphql",
    get: function get() {
      return this._graphql || (this._graphql = new GraphQLHandler(this.transport));
    }
  }, {
    key: "singleton",
    value: function singleton(collection) {
      return this._singletons[collection] || (this._singletons[collection] = new SingletonHandler(collection, this.transport));
    }
  }, {
    key: "items",
    value: function items(collection) {
      return this._items[collection] || (this._items[collection] = new ItemsHandler(collection, this.transport));
    }
  }]);
  return Directus;
}();
export { ActivityHandler, AssetsHandler, Auth, BaseStorage, CollectionsHandler, CommentsHandler, Directus, EmptyParamError, FieldsHandler, FilesHandler, FoldersHandler, IAuth, IStorage, ITransport, ItemsHandler, LocalStorage, MemoryStorage, Meta, PermissionsHandler, PresetsHandler, RelationsHandler, RevisionsHandler, RolesHandler, ServerHandler, SettingsHandler, Transport, TransportError, UsersHandler, UtilsHandler };